import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import SEOHead from '../../components/seo/SEOHead';

export default function TermsOfServicePage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://neurasites.ai';

  return (
    <div className="min-h-screen bg-white dark:bg-gray-900 transition-colors">
      <SEOHead
        title="Terms of Service | NeuraSites AI"
        description="Terms of Service for NeuraSites AI website and services."
        canonicalUrl={`${siteUrl}/terms-of-service`}
      />
      <Header />
      <main className="pt-24 pb-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-6">Terms of Service</h1>
          <p className="text-gray-600 dark:text-gray-300 mb-6">Last updated: February 2026</p>

          <div className="space-y-6 text-gray-700 dark:text-gray-300 leading-relaxed">
            <section>
              <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-2">Services</h2>
              <p>NeuraSites AI provides web design, development, and related digital services as described in proposals and client agreements.</p>
            </section>
            <section>
              <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-2">Payments</h2>
              <p>Project pricing, deposits, and billing schedules are defined per engagement. Late payments may delay deliverables.</p>
            </section>
            <section>
              <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-2">Client Responsibilities</h2>
              <p>Clients are responsible for providing timely content, feedback, approvals, and legal rights to assets provided for use.</p>
            </section>
            <section>
              <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-2">Intellectual Property</h2>
              <p>Ownership and licensing terms for deliverables are governed by the signed project agreement.</p>
            </section>
            <section>
              <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-2">Limitation of Liability</h2>
              <p>To the fullest extent permitted by law, NeuraSites AI is not liable for indirect, incidental, or consequential damages.</p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
